import { createFileRoute } from '@tanstack/react-router';

import { CostGroupsPage } from '@/features/catalog/CostGroupsPage';

/**
 * Подчинённая страница каталога. Подчёркивание в имени файла (`catalog_`) отвязывает её от
 * компонента каталога: адрес вложенный, а экран самостоятельный — списка товаров под ним нет.
 */
export const Route = createFileRoute('/_app/catalog_/cost-groups')({
  component: CostGroupsPage,
});
